import {UsuarioPesquisa} from './usuario';
import {FTA, Servico, Operacao, Layout, InstalacaoProduto, Cliente} from './catalogo';

export class FiltrosDeServico {
    'filtroServico': FiltroServico;
    'filtroAlteracaoEstado': FiltroAlteracaoEstado;
    'metadata': FiltroMetadata;
}

export class FiltrosDeInstalacaoProduto {
    'filtroInstalacaoProduto': FiltroInstalacaoProduto;
    'filtroAlteracaoEstado': FiltroAlteracaoEstado;
    'metadata': FiltroMetadata;
}

export class FiltrosDeLayout {
    'filtroLayout': FiltroLayout;
    'filtroAlteracaoEstado': FiltroAlteracaoEstado;
    'metadata': FiltroMetadata;
}

export class FiltrosDeOperacao extends FiltrosDeServico {
    'filtroOperacao': FiltroOperacao;
}

export class FiltroServico {
    'codigo': number;
    'versao': number;
    'nome': string;
    'descricao': string;
    'codTipoEstado': number;
}

export class FiltroAlteracaoEstado {
    'codTipoEstado': number;
    'dataInicial': string;
    'dataFinal': string;
    'matricula': string;
}

export class FiltroOperacao {
    'codigo': number;
    'versao': number;
    'nome': string;
    'descricao': string;
    'codTipoEstado': number;
}

export class FiltroLayout {
    'codigo': number;
    'versao': number;
    'nome': string;
    'descricao': string;
    'conteudoHeader': string;
    'codTipoEstado': number;
}

export class FiltroInstalacaoProduto {
    'codigo': number;
    'versao': number;
    'nomeInstalacao': string;
    'nomeItemConfiguracaoProduto': string;
    'descricao': string;
    'parmInstalacao': Array<FiltroParametroInstalacao>;
    'itemConfiguracaoVinculado': string;
    'clienteVinculado': Cliente;
    'codTipoEstado': number;
}

export class FiltroParametroInstalacao {
    'nomeParm': string;
    'valorParm': string;
}

export class FiltroCliente {
    'codTipoCliente': number;
    'userAplicacao': FiltroUserAplicacao;
    'mci': FiltroMCI;
    'uor': FiltroUOR;
}

export class FiltroUserAplicacao {
    'codUserAplicacao': number;
    'versaoUserAplicacao': number;
    'nomeUserAplicacao': string;
    'nomeCertificadoVinculado': string;
    'mciVinculado': string;
    'uorVinculada': string;
    'descricaoUserAplicacao': string;
    'codTipoEstado': number;
}

export class FiltroMCI {
    'codMci': number;
    'nomeCliente': string;
}

export class FiltroUOR {
    'codUor': number;
    'nomeDependencia': string;
}

export class FiltroItemConfiguracao {
    'tipoItemConfiguracao': number;
    'nomeItemConfiguracao': string;
}

export class FiltroDadosFta {
    'fta': number;
    'versao': number;
    'nome': string;
    'codTipoEstado': number;
    'ordenacao': string;
}

export class FiltroFta {
    'filtroFta': FiltroDadosFta;
    'filtroItemConfiguracao': FiltroItemConfiguracao;
    'filtroInstalacaoProduto': FiltroInstalacaoProduto;
    'filtroCliente': FiltroCliente;
    'filtroServico': FiltroServico;
    'filtroAlteracaoEstado': FiltroAlteracaoEstado;
}

export class FiltroMetadata {
    'pagina': number;
    'porPagina': number;
    'ordenacao': string;
}

export class Metadata {
    'paginaAtual': number;
    'paginaTotal': number;
    'resultados': number;
    'resultadoTotal': number;
}

export class ResultadoFiltroFta {
    'metadata': Metadata;
    'resultados': Array<FTA>;
}

export class ResultadoListaFtaSia {
    'remessa': Array<FTA>;
    'retorno': Array<FTA>;
}

export class FiltroUsuarioAplicacao {
    'filtros': Array<UsuarioPesquisa>;
    'filtroAlteracaoEstado': FiltroAlteracaoEstado;
}

export class ResultadoUsuarioAplicacao {
    'resultados': Array<UsuarioPesquisa>;
}

export class historico {
    'dataHora': string;
    'codTipoEstado': number;
    'nomeTipoEstado': string;
    'matricula': string;
    'observacao': string;
    'dataHoraFormatada': string;
}

export class ResultadoFiltroDetalhaServico {
    'codigo': number;
    'versao': number;
    'nome': string;
    'descricao': string;
    'codTipoEstado': number;
    'historico': any[];
}

export class ResultadoFiltroDetalhaLayout {
    'codigo': number;
    'versao': number;
    'nome': string;
    'descricao': string;
    'codTipoEstado': number;
    'nomeTipoEstado': String;
    'header': any[];
    'historico': any[];
}

export class ResultadoFiltroDetalhaOperacao {
    'codigo': number;
    'versao': number;
    'nome': string;
    'descricao': string;
    'codTipoEstado': number;
    'historico': any[];
}

export class ResultadoFiltroServico {
    'metadata': Metadata;
    'servicos': Servico[];
}

export class ResultadoFiltroInstalacaoProduto {
    'metadata': Metadata;
    'instalacoesProduto': InstalacaoProduto[];
}

export class ResultadoFiltroLayout {
    'metadata': Metadata;
    'layouts': Layout[];
}

export class header {
    'posicaoInicial': number;
    'posicaoFinal': number;
    'conteudo': string;
}

export class ResultadoFiltroOperacao {
    'metadata': Metadata;
    'operacoes': Operacao[];
}

export class ResultadoFiltroFta2 {
    'metadata': Metadata;
    'ftas': Array<FTA2>;
}

export class VersaoFTA {
    'versao': number;
    'nome': string;
    'descricao': string;
    'codTipoEstado': number;
    'codModelo': number;
    'contratoIed': number;
    'formatoIed': string;
    'validade': string;
    'dataCriacao': string;
    'indicadorExclusao': boolean;
    'indicadorAtendimentoFiltros': boolean;
    'indicadorStepRoteiroPendenteDemandante': boolean;
    'indicadorStepRoteiroPendenteSuporte': boolean;
}

export class FTA2 {
    'fta': number;
    'versoes': Array<VersaoFTA>;
}

export class FTAFamily {
    'codFTA': string;
    'codFTAPai': string;
    'versao': string;
    'nome': string;
    'descricao': string;
    'codTipoEstado': number;
    'codModelo': number;
    'contratoIed': number;
    'formatoIed': string;
    'validade': string;
    'dataCriacao': string;
    'indicadorExclusao': boolean;
    'indicadorAtendimentoFiltros': boolean;
}

export class Metadata2 {
    'pagina': number;
    'porPagina': number;
    'colunaOrdenacao': string;
    'ordenacao': string;
}

export class FiltroFTa2 {
    'filtroFta': Fta2;
    'filtroAlteracaoEstado': FiltroAlteracaoEstado2;
}

export class Fta2 {
    'fta': number;
    'versao': number;
    'nome': string;
    'descricao': string;
    'modeloMin': number;
    'modeloMax': number;
    'qtdEventosMin': number;
    'qtdEventosMax': number;
    'contratoIed': number;
    'formatoIed': string;
    'codTipoEstado': number;
    'nomeProdutoTransmissao': string;
    'nomeInstalacaoProduto': string;
    'codMci': number;
    'codUor': number;
    'nomeUsrImpessoal': string;
    'nomeServicoVinculado': string;
    'itemConfiguracaoVinculado': string;
    'parametroTransmissaoNome': string;
    'parametroTransmissaoConteudo': string;
    'nomeOperacaoVinculada': string;
    'parametroOperacaoNome': string;
    'parametroOperacaoConteudo': string;
}

export class FiltroAlteracaoEstado2 {
    'codTipoEstado': 0;
    'dataInicial': 'string';
    'dataFinal': 'string';
    'matricula': 'string';
}

export class FiltroPesquisaFTA2 {
    'metadata': Metadata2;
    'incluirTodasVersoesFTA': boolean;
    'filtros': Array<FiltroFTa2>;
}



// WEBPACK FOOTER //
// ./src/model/filtros.ts